<!-- eslint-disable vue/no-side-effects-in-computed-properties -->
<template>
  <nav
    class="fixed top-0 h-14 z-50 w-full bg-white border-gray-200 dark:bg-bgLightDark"
  >
    <!--in ltr change lg:pr-3 to lg:pl-3-->
    <div class="px-3 py-1 lg:px-5 lg:pr-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center justify-start">
          <div class="flex flex-col my-2">
            <a
              href="/sold-list"
              class="flex text-xl dark:text-textWhite"
              id="darkModeToggle"
            >
              <!-- <img src="/assets/image/kcStore.png" alt="" class="w-16 lg:w-20 mx-3"> -->
              <i class="fa-solid fa-chevron-right my-auto mx-2"></i>
              {{ $t("app_name") }}
            </a>
          </div>
          <div class="w-10"></div>
          <div class="dark:text-white">
            {{ $t("dolar_price") }} : {{ formatNumber(in_main_currency_price) }}
          </div>
        </div>
        <div class="flex items-center">
          <!-- Prev/Next invoice navigation -->
          <div class="flex items-center mr-2 space-x-2">
            <button
              type="button"
              class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 shadow-sm hover:bg-blue-100 dark:hover:bg-blue-900/50 hover:shadow focus:outline-none focus:ring-2 focus:ring-blue-400 dark:focus:ring-blue-500 transition"
              :title="$t('prev')"
              @click="goToPrevInvoice"
            >
              <i
                class="fa-solid"
                :class="[
                  $store.getters['isRtl'] ? 'fa-angle-right' : 'fa-angle-left',
                ]"
              ></i>
            </button>
            <button
              type="button"
              class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 shadow-sm hover:bg-blue-100 dark:hover:bg-blue-900/50 hover:shadow focus:outline-none focus:ring-2 focus:ring-blue-400 dark:focus:ring-blue-500 transition"
              :title="$t('next')"
              @click="goToNextInvoice"
              v-if="!isLastInvoice"
            >
              <i
                class="fa-solid"
                :class="[
                  $store.getters['isRtl'] ? 'fa-angle-left' : 'fa-angle-right',
                ]"
              ></i>
            </button>
          </div>
          <!-- Calculator Button -->
          <div class="mx-2">
            <button
              @click="openCalculator"
              type="button"
              class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-400 dark:focus:ring-blue-500 transition"
              title="Calculator"
            >
              <span class="sr-only">Calculator</span>
              <i class="fa-solid fa-calculator text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <LoadingProgress v-show="isLoadingData" />

  <div
    class="mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl"
  >
    <div class="flex flex-wrap mb-4 justify-between">
      <p
        class="font-semibold text-xl text-textBlack dark:text-textWhite mx-3 my-2 lg:my-0"
      >
        {{ $t("edit_invoice_number") }} #{{ in_id }}
      </p>
      <p
        class="font-semibold text-xl text-textBlack dark:text-textWhite mx-3 my-2 lg:my-0"
      >
        {{ $t("admin") }} {{ name }}
      </p>
      <p
        class="font-semibold text-xl text-textBlack dark:text-textWhite mx-3 my-2 lg:my-0"
      >
        {{ $t("date") }} : {{ formatDate(created_at) }}
      </p>
      <div
        class="font-semibold text-lg text-textBlack dark:text-textWhite mx-3 my-2 lg:my-0"
      >
        <span v-show="in_status == 1" class="text-success">
          {{ $t("invoice_status") + " : " + $t("sold") }}</span
        >
        <span v-show="in_status != 1" class="text-red-500">
          {{ $t("invoice_status") + " : " + $t("returned") }}</span
        >
      </div>
      <div class="my-2 lg:my-0">
        <label
          for="boxType"
          class="block mb-1 text-sm text-textBlack1 dark:text-textWhite1"
          >{{ $t("currency_invoice_type") }}</label
        >
        <button
          id="boxType"
          class="bg-white border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1.5 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <i
            class="fa-solid fa-arrows-rotate text-primaryColor mx-1 text-sm"
          ></i>
          <span class="mx-1" v-show="cur_id == 1">{{ $t("dinar") }}</span>
          <span class="mx-1" v-show="cur_id == 2">{{ $t("dollar") }}</span>
        </button>
      </div>
    </div>
    <div class="md:flex">
      <div class="w-full md:w-5/12 flex flex-col py-3 mx-auto md:mx-0">
        <div
          class="flex bg-white dark:bg-bgMeduimDark rounded-2xl p-3 w-full overflow-x-auto space-x-2 whitespace-nowrap mb-4"
        >
          <BaseInput
            :modelValue="$store.state.sale_pos.searchPos"
            @update:modelValue="handleSearchInput"
            :placeholder="$t('search_item')"
            :prefixIcon="'fa-solid fa-search'"
            class="w-full"
          />

          <div class="w-6"></div>

          <form @submit="enterBarcode">
            <BaseInput
              v-model="barcode"
              :placeholder="$t('barcode')"
              :prefixIcon="'fa-solid fa-barcode'"
              class="w-full"
            />
          </form>
        </div>
        <h2
          id="accordion-color-heading-2"
          :class="
            isShowItemsCategorys ? 'border-primaryColor text-blue-600' : ''
          "
        >
          <button
            type="button"
            class="flex bg-slate-100 dark:bg-bgFullDark items-center justify-between w-full px-4 py-2 font-medium text-right text-textBlack1 dark:text-textWhite1 border-l-0 border-r-0 border border-gray-300 dark:border-gray-600 hover:border-primaryColor"
            @click="isShowItemsCategorys = !isShowItemsCategorys"
          >
            <span>{{ $t("items") + " & " + $t("items_categorys") }} </span>
            <svg
              data-accordion-icon
              class="w-3 h-3 rotate-180 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h2>
        <div
          class="flex flex-wrap gap-2 bg-white dark:bg-bgMeduimDark rounded-2xl p-3 w-full overflow-x-auto space-x-2 whitespace-nowrap mb-4"
          v-if="isShowItemsCategorys"
        >
          <button
            :class="
              'px-3 py-1 text-sm bg-white dark:bg-bgMeduimDark text-textBlack2 dark:text-textWhite3 rounded-xl border ' +
              (this.$store.state.sale_pos.ca_id == ''
                ? 'border-primaryColor dark:border-primaryColor'
                : 'border-gray-300 dark:border-gray-600')
            "
            @click="this.$store.state.sale_pos.ca_id = ''"
          >
            {{ $t("all_items") }}
          </button>
          <button
            :class="
              'px-3 py-1 text-sm bg-white dark:bg-bgMeduimDark text-textBlack2 dark:text-textWhite3 rounded-xl border ' +
              (this.$store.state.sale_pos.ca_id == category.ca_id
                ? 'border-primaryColor dark:border-primaryColor'
                : 'border-gray-300 dark:border-gray-600')
            "
            v-for="(category, index) in this.$store.state.item_category
              .categorys"
            :key="index"
            @click="this.$store.state.sale_pos.ca_id = category.ca_id"
          >
            {{ category.ca_name }}
          </button>
        </div>
        <div
          class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 pb-10"
          v-if="isShowItemsCategorys"
        >
          <!-- item 1-->
          <div
            :class="
              'flex flex-col p-2 bg-white dark:bg-bgMeduimDark rounded-2xl items-center shadow-sm p-2 cursor-pointer ' +
              (checkHowMuchItemInCard(item.i_id) != 0
                ? 'border border-primaryColor dark:border-primaryColor'
                : 'border-gray-300 dark:border-gray-600')
            "
            v-for="(item, index) in filterItemsPos"
            :key="index"
          >
            <div class="mb-1">
              <button
                type="button"
                @click="removeItem(item.i_id)"
                class="text-left mb-1 mx-1"
                v-if="checkHowMuchItemInCard(item.i_id) != 0"
              >
                <i
                  class="fa-solid fa-trash text-center p-1 w-6 h-6 text-xs bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto my-auto"
                ></i>
              </button>

              <a
                class="text-left mb-1 mx-1"
                :href="'item-detail/' + item.i_id"
                target="_blank"
              >
                <i
                  class="fa-solid fa-eye text-center p-1 w-6 h-6 text-xs bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto my-auto"
                ></i>
              </a>
            </div>
            <img
              :src="getItemImage(item)"
              alt=""
              class="mb-1 rounded-xl h-24 cursor-pointer"
              @click="addItemToInvoice(item)"
            />

            <p
              class="text-textBlack1 dark:text-textWhite1 text-sm text-center cursor-pointer"
              @click="addItemToInvoice(item)"
            >
              {{ item.i_name }}
            </p>

            <p
              class="text-textBlack2 dark:text-textWhite2 cursor-pointer"
              @click="addItemToInvoice(item)"
            >
              {{ formatNumber(item.i_sale_price) }}
              {{ this.$t(item.currency.cur_name) }}
            </p>
            <p
              class="text-textBlack1 dark:text-textWhite1 text-sm text-center cursor-pointer"
              @click="addItemToInvoice(item)"
            >
              {{ $t("remain") }} {{ item.i_quantity }}
            </p>
            <span
              v-show="checkHowMuchItemInCard(item.i_id) != 0"
              class="bg-green-500 px-3 py-2 text-white rounded-full text-xs mt-2"
              @click="addItemToInvoice(item)"
            >
              {{ checkHowMuchItemInCard(item.i_id) }}
            </span>
          </div>
        </div>
        <center>
          <span
            v-show="filterItemsPos.length == 0 && isLoadingData == false"
            class="text-textBlack1 dark:text-white"
          >
            {{ $t("no_item_found") }}
          </span>
        </center>
        <center>
          <img
            src="../../assets/loading.webp"
            style="width: 70px; height: 70px"
            v-show="isLoadingData"
          />
        </center>
      </div>
      <div class="w-4"></div>

      <div
        class="w-full md:w-7/12 my-3 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl mb-20 md:mb-14 mx-auto md:mx-0"
      >
        <form action="">
          <!--sale extra information-->

          <div id="accordion-color">
            <h2
              id="accordion-color-heading-1"
              :class="isShowDetail ? 'border-primaryColor text-blue-600' : ''"
            >
              <button
                type="button"
                class="flex bg-slate-100 dark:bg-bgFullDark items-center justify-between w-full px-4 py-2 font-medium text-right text-textBlack1 dark:text-textWhite1 border-l-0 border-r-0 border border-gray-300 dark:border-gray-600 hover:border-primaryColor"
                @click="isShowDetail = !isShowDetail"
              >
                <span>{{ $t("detail") }}</span>
                <svg
                  data-accordion-icon
                  class="w-3 h-3 rotate-180 shrink-0"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5 5 1 1 5"
                  />
                </svg>
              </button>
            </h2>

            <!-- extra sale information-->
            <div
              id="accordion-color-body-1"
              aria-labelledby="accordion-color-heading-1"
              v-show="isShowDetail"
            >
              <div class="p-5 grid grid-cols-2 gap-x-3">
                <DropdownInput
                  v-model="bo_id"
                  :label="$t('box')"
                  :isDisabled="true"
                  :placeholder="$t('choose_box_that_money_get_in')"
                  :rules="no_rule"
                  :items="convertToListIdValueBoxes"
                  :isError="
                    checkRulesIsError(bo_id, 'add', this.no_rule).isError
                  "
                  :errorMsg="
                    checkRulesIsError(bo_id, 'add', this.no_rule).errorMsg
                  "
                />
                <DropdownInput
                  v-model="st_id"
                  :label="$t('sale_type')"
                  :placeholder="$t('choose_sale_type')"
                  :rules="rules_dropdown"
                  :items="convertToListIdValueSaleTypes"
                  :isError="
                    checkRulesIsError(st_id, 'add', this.rules_dropdown).isError
                  "
                  :errorMsg="
                    checkRulesIsError(st_id, 'add', this.rules_dropdown)
                      .errorMsg
                  "
                />

                <div class="mb-6">
                  <DropdownInput
                    v-model="cu_id"
                    :label="$t('customer')"
                    :placeholder="$t('choose_customer')"
                    :items="convertToListIdValueCustomers"
                    :rules="rules_dropdown"
                    :isError="
                      checkRulesIsError(cu_id, 'add', this.rules_dropdown).isError
                    "
                    :errorMsg="
                      checkRulesIsError(cu_id, 'add', this.rules_dropdown).errorMsg
                    "
                  />
                </div>
                <DropdownInput
                  v-model="pl_id"
                  :label="$t('sale_platform')"
                  :placeholder="$t('choose_sale_platform')"
                  :rules="rules_dropdown"
                  :items="convertToListIdValuePlatforms"
                  :isError="
                    checkRulesIsError(pl_id, 'add', this.rules_dropdown).isError
                  "
                  :errorMsg="
                    checkRulesIsError(pl_id, 'add', this.rules_dropdown)
                      .errorMsg
                  "
                />
                <BaseInput
                  v-model="created_at"
                  type="date"
                  :label="$t('sale_date')"
                  :placeholder="$t('sale_date')"
                  :rules="no_rule"
                  :isError="
                    checkRulesIsError(created_at, 'add', this.no_rule).isError
                  "
                  :errorMsg="
                    checkRulesIsError(created_at, 'add', this.no_rule).errorMsg
                  "
                />
                <TextAreaInput
                  v-model="in_note"
                  :label="$t('note')"
                  :placeholder="$t('note')"
                  :rules="no_rule"
                  :isError="
                    checkRulesIsError(in_note, 'add', this.no_rule).isError
                  "
                  :errorMsg="
                    checkRulesIsError(in_note, 'add', this.no_rule).errorMsg
                  "
                />
                <div>
                  <label
                    for="currency"
                    class="block mb-2 text-base font-medium text-textBlack1 dark:text-textWhite1"
                    >{{ $t("do_you_want_to_show_item_cost_price") }}</label
                  >
                  <div class="flex mx-4 mt-4">
                    <div class="flex items-center ml-4">
                      <input
                        id="inline-radio111"
                        type="radio"
                        value="1"
                        checked="true"
                        v-model="isShowCost"
                        name="inline-radio-group11"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        @change="costStatus"
                      />
                      <label
                        for="inline-radio"
                        class="mr-2 text-base font-medium text-gray-900 dark:text-gray-300"
                        >{{ $t("yes") }}</label
                      >
                    </div>
                    <div class="flex items-center ml-4">
                      <input
                        id="inline-2-radio111"
                        type="radio"
                        value="2"
                        v-model="isShowCost"
                        @change="costStatus"
                        name="inline-radio-group11"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        for="inline-2-radio"
                        class="mr-2 text-base font-medium text-gray-900 dark:text-gray-300"
                        >{{ $t("no") }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--table-->
          <div class="relative overflow-x-auto mt-10 mb-6 overflow-y-auto">
            <!--in ltr change (text-right to text-left)-->
            <table class="w-full text-right text-gray-500 dark:text-gray-400">
              <thead
                class="text-xs text-gray-600 border-l-0 border-r-0 border border-gray-300 dark:border-gray-600 uppercase bg-slate-100 dark:bg-bgFullDark dark:text-gray-400"
              >
                <tr>
                  <th scope="col" class="px-2 py-1">{{ $t("item_name") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("barcode") }}</th>
                  <th scope="col" class="px-2 py-1" v-if="isShowCost == '1'">
                    {{ $t("cost") }}
                  </th>
                  <th scope="col" class="px-2 py-1">{{ $t("price") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("quantity") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("bonus") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("unit") }}</th>
                  <th scope="col" class="px-2 py-1" v-if="hasItemsWithPackages">{{ $t("packages") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("discount") }}</th>
                  <th scope="col" class="px-2 py-1" v-if="isShowCost == '1'">
                    {{ $t("total_cost") }}
                  </th>
                  <th scope="col" class="px-2 py-1">{{ $t("final_price") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("actions") }}</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr
                  class="bg-white text-textBlack border-b dark:bg-bgLightDark dark:text-textWhite2 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-bgFullDark"
                  v-for="(item, index) in getSoldListByCurrentCurrency"
                  :key="index"
                >
                  <td class="px-2 py-2">
                    {{ item.item.i_name }}
                  </td>
                  <td class="px-2 py-2">
                    {{ item.item.i_barcode }}
                  </td>
                  <td class="px-2 py-2" v-if="isShowCost == '1'">
                    {{ item.si_cost_price }}
                  </td>
                  <td class="px-2 py-2">
                    <!-- For size items, show price per bottle; for regular items, show price per unit -->
                    <input
                      v-if="item.selected_size && item.selected_size.is_size"
                      type="number"
                      class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      :value="formatPriceForInput(item)"
                      @input="updateSizeItemPrice(item, $event)"
                      @blur="updateSizeItemPrice(item, $event)"
                      min="0"
                      :step="(item.cur_id || cur_id) == 1 ? 1 : 0.01"
                    />
                    <input
                      v-else
                      type="number"
                      class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      v-model="item.si_sale_price"
                      min="0"
                    />
                  </td>
                  <td class="px-2 py-2">
                    <!-- For size items, show bottle quantity controls -->
                    <div v-if="item.selected_size" class="flex items-center gap-1">
                      <button
                        type="button"
                        @click.stop="decreaseBottleQuantity(index)"
                        class="bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 px-2 py-1 rounded text-sm font-bold"
                        :disabled="item.bottle_quantity <= 1"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        :ref="`quantity-input-${item.i_id || (item.item && item.item.i_id)}-${index}`"
                        class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-14 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        required
                        v-model.number="item.bottle_quantity"
                        min="1"
                        @input="updateBottleQuantity(index, item.bottle_quantity)"
                      />
                      <button
                        type="button"
                        @click.stop="increaseBottleQuantity(index)"
                        class="bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 px-2 py-1 rounded text-sm font-bold"
                      >
                        +
                      </button>
                    </div>
                    <!-- For regular items, show standard quantity input -->
                    <input
                      v-else
                      type="number"
                      class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-14 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      v-model="item.si_quantity"
                      min="0"
                      @input="calculateDue(item, item.si_quantity)"
                    />
                  </td>
                  <td class="px-2 py-2">
                    <!-- For size items, show bonus in bottles; for regular items, show directly -->
                    <input
                      v-if="item.selected_size && item.selected_size.is_size"
                      type="number"
                      class="bg-slate-100 border border-green-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-14 p-2 dark:bg-bgFullDark dark:border-green-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      :value="getDisplayBonusQuantity(item)"
                      @input="updateBonusQuantity(item, $event)"
                      @blur="updateBonusQuantity(item, $event)"
                      min="0"
                      placeholder="0"
                      :title="$t('bonus_gift_items')"
                    />
                    <input
                      v-else
                      type="number"
                      class="bg-slate-100 border border-green-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-14 p-2 dark:bg-bgFullDark dark:border-green-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      v-model="item.si_bonus_quantity"
                      min="0"
                      placeholder="0"
                      :title="$t('bonus_gift_items')"
                    />
                  </td>
                  <td class="px-2 py-2">
                    <!-- For size items, show the size -->
                    <div v-if="item.selected_size" class="flex items-center gap-2">
                      <span class="text-sm bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded">
                        {{ item.selected_size.is_size }}
                      </span>
                    </div>
                    <span v-else>{{ getUnit(item) }}</span>
                  </td>
                  <td class="px-2 py-2" v-if="hasItemsWithPackages">
                    <div v-if="item.item && item.item.i_packages && item.item.i_packages.length > 0" class="space-y-1">
                      <div
                        v-for="(pkg, pkgIndex) in item.item.i_packages"
                        :key="pkgIndex"
                        class="text-xs bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded cursor-pointer hover:bg-blue-200 dark:hover:bg-blue-800 transition-colors"
                        @click="setQuantityFromPackage(item, pkg.quantity, pkg.price)"
                        :title="$t('click_to_set_quantity')"
                      >
                        {{ pkg.name }}: {{ pkg.quantity }}+ = {{ formatNumber(pkg.price) }}
                      </div>
                    </div>
                    <span v-else class="text-gray-400 text-xs">
                      {{ $t("no_packages") }}
                    </span>
                  </td>
                  <td class="px-2 py-2">
                    <input
                      type="number"
                      class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      v-model="item.si_discount"
                      min="0"
                    />
                  </td>
                  <td class="px-2 py-2" v-if="isShowCost == '1'">
                    {{ item.si_quantity * item.si_cost_price }}
                  </td>
                  <td class="px-2 py-2">
                    {{
                      formatNumber(
                        getItemPrice(item) -
                          item.si_discount
                      )
                    }}
                    <span v-if="item.si_bonus_quantity > 0" class="text-green-600 dark:text-green-400 text-xs block">
                      +{{ getDisplayBonusQuantity(item) }} {{ $t("free") }}
                    </span>
                    <span class="mx-1" v-show="cur_id == 1">{{
                      $t("dinar")
                    }}</span>
                    <span class="mx-1" v-show="cur_id == 2">{{
                      $t("dollar")
                    }}</span>
                  </td>
                  <td class="px-2 py-2 flex mt-2">
                    <div @click="removeItem(item.i_id)" class="curser-pointer">
                      <i
                        class="fa-solid fa-trash text-center p-1 w-6 h-6 text-xs bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto my-auto"
                      ></i>
                    </div>
                  </td>
                </tr>
                <tr
                  class="bg-white text-textBlack border-b dark:bg-bgLightDark dark:text-textWhite2 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-bgFullDark"
                  v-show="sold_list.length != 0"
                >
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2">
                    <div
                      class="text-sm font-medium text-gray-600 dark:text-gray-400"
                    >
                      {{ $t("total_without_discount") }}:
                    </div>
                    {{ formatNumber(sumPriceWithoutDiscount) }}
                    <span class="mx-1" v-show="cur_id == 1">{{
                      $t("dinar")
                    }}</span>
                    <span class="mx-1" v-show="cur_id == 2">{{
                      $t("dollar")
                    }}</span>
                  </td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2" v-if="isShowCost == '1'"></td>
                  <td class="px-2 py-2">
                    {{ $t("discount_amount") }} : {{ formatNumber(sumDiscount)
                    }}<span class="mx-1" v-show="cur_id == 1">{{
                      $t("dinar")
                    }}</span>
                    <span class="mx-1" v-show="cur_id == 2">{{
                      $t("dollar")
                    }}</span>
                  </td>
                  <td class="px-2 py-2">
                    {{ $t("total_price") }} : {{ formatNumber(sumPrice) }}
                    <span class="mx-1" v-show="cur_id == 1">{{
                      $t("dinar")
                    }}</span>
                    <span class="mx-1" v-show="cur_id == 2">{{
                      $t("dollar")
                    }}</span>
                  </td>
                </tr>
                <tr
                  class="bg-white text-textBlack border-b dark:bg-bgLightDark dark:text-textWhite2 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-bgFullDark"
                  v-show="sold_list.length != 0"
                >
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2" v-if="isShowCost == '1'"></td>
                  <td class="px-2 py-2">
                    <div class="flex flex-col space-y-2">
                      <div class="flex items-center space-x-2">
                        <label
                          class="text-sm font-medium text-gray-700 dark:text-gray-300"
                        >
                          {{ $t("total_discount") }}:
                        </label>
                        <input
                          type="number"
                          class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-20 p-1 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          v-model="total_discount"
                          min="0"
                          @input="applyTotalDiscount"
                        />
                        <span class="text-xs" v-show="cur_id == 1">{{
                          $t("dinar")
                        }}</span>
                        <span class="text-xs" v-show="cur_id == 2">{{
                          $t("dollar")
                        }}</span>
                      </div>
                      <div class="flex items-center space-x-2">
                        <label
                          class="text-sm font-medium text-gray-700 dark:text-gray-300"
                        >
                          {{ $t("percentage_discount") }}:
                        </label>
                        <input
                          type="number"
                          class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-16 p-1 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          v-model="percentage_discount"
                          min="0"
                          max="100"
                          @input="applyPercentageDiscount"
                        />
                        <span class="text-xs">%</span>
                      </div>
                    </div>
                  </td>
                  <td class="px-2 py-2" v-if="isShowCost == '1'">
                    {{ $t("total_cost") }} : {{ formatNumber(sumCost) }}
                    <span class="mx-1" v-show="cur_id == 1">{{
                      $t("dinar")
                    }}</span>
                    <span class="mx-1" v-show="cur_id == 2">{{
                      $t("dollar")
                    }}</span>
                  </td>

                  <td class="px-2 py-2 flex mt-2"></td>
                </tr>
                <tr
                  class="bg-white text-textBlack border-b dark:bg-bgLightDark dark:text-textWhite2 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-bgFullDark"
                  v-show="sold_list.length != 0"
                >
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2" v-if="isShowCost == '1'"></td>

                  <td class="px-2 py-2" v-if="isShowCost == '1'"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2 flex mt-2"></td>
                </tr>
              </tbody>
            </table>
            <center>
              <span
                class="text-center text-textBlack1 dark:text-white"
                v-show="sold_list.length == 0"
                >{{ $t("no_item_in_invoice") }}</span
              >
            </center>
          </div>
        </form>
      </div>
    </div>

    <div
      class="flex justify-between items-center px-4 md:px-16 py-3 left-0 right-0 fixed bottom-0 bg-white dark:bg-bgMeduimDark rounded-tl-xl z-50"
    >
      <div class="md:flex items-baseline">
        <p class="text-sm md:text-base text-textBlack1 dark:text-white">
          {{ $t("total_items_price") }} :
          <span class="text-xl md:text-2xl font-bold"
            >{{ formatNumber(sumPrice)
            }}<span class="mx-1" v-show="cur_id == 1">{{ $t("dinar") }}</span>
            <span class="mx-1" v-show="cur_id == 2">{{
              $t("dollar")
            }}</span></span
          >
        </p>

        <div class="flex mx-0 md:mx-6 items-center my-3 lg:my-0">
          <span
            class="text-sm md:text-base font-medium text-textBlack1 dark:text-textWhite1 mx-1"
            >{{ $t("money_amount_received") }}:</span
          >
          <input
            type="number"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 w-20 md:w-40 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
            v-model="in_paid"
            min="0"
          />
        </div>

        <p class="text-sm md:text-base mx-2 text-textBlack1 dark:text-white">
          {{ $t("debt") }}:
          <span class="text-xl md:text-2xl font-bold">{{
            formatNumber(sumPrice - in_paid)
          }}</span>
        </p>
      </div>

      <div class="lg:flex">
        <div class="flex justify-between mb-1 lg:mb-0">
          <button
            data-modal-target="defaultModal"
            data-modal-toggle="defaultModal"
            :class="[
              'text-white px-2 text-lg md:text-xl px-4 md:px-8 py-2 rounded items-center',
              hasUnsavedChanges 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-green-500 hover:shadow-md'
            ]"
            @click="hasUnsavedChanges ? showUnsavedWarning() : modalPrintID()"
            :disabled="hasUnsavedChanges"
            :title="hasUnsavedChanges ? $t('please_save_changes_before_printing') : $t('print')"
          >
            <i class="fa-solid fa-print"></i>
          </button>
          <div class="w-2 md:w-4"></div>
          <button
            :class="[
              'text-white px-2 text-lg md:text-xl px-4 md:px-8 py-2 rounded items-center',
              hasUnsavedChanges 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-blue-500 hover:shadow-md'
            ]"
            @click="hasUnsavedChanges ? showUnsavedWarning() : modalPrintIDA4()"
            :disabled="hasUnsavedChanges"
            :title="hasUnsavedChanges ? $t('please_save_changes_before_printing') : $t('a4')"
          >
            <span v-if="isPrintLoading == false">
              {{ $t("a4") }}
            </span>
            <div
              class="flex items-center hover:shadow-mdtext-white flex justify-center items-center hover:shadow-md"
              role="status"
              v-else
            >
              <svg
                width="20"
                height="20"
                fill="currentColor"
                class="mr-2 animate-spin"
                viewBox="0 0 1792 1792"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-
56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"
                ></path>
              </svg>
            </div>
          </button>

          <div class="w-2 md:w-4"></div>
          <button
            data-modal-target="defaultModal"
            data-modal-toggle="defaultModal"
            class="text-white px-2 text-lg md:text-xl bg-blue-300 px-4 md:px-8 py-2 rounded items-center hover:shadow-md"
            @click="showModal(item)"
          >
            <i class="fa-solid fa-calculator"></i>
          </button>
          <div class="w-2 md:w-4"></div>
          <button
            data-modal-target="defaultModal"
            data-modal-toggle="defaultModal"
            class="text-white px-2 text-lg md:text-xl bg-red-500 px-4 md:px-8 py-2 rounded items-center hover:shadow-md"
            @click="removeInvoice"
            v-show="in_status == 1"
            v-if="
              $store.getters['checkUserAccess']({
                id: '19',
                action: 'delete',
              })
            "
          >
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

        <div class="w-2 md:w-4"></div>
        <button
          class="text-white text-lg md:text-xl bg-success px-2 w-40 md:w-72 lg:w-40 py-2 rounded items-center hover:shadow-md"
          @click="addSaleItem"
          v-show="in_status == 1"
          v-if="
            $store.getters['checkUserAccess']({
              id: '19',
              action: 'edit',
            })
          "
        >
          <div v-if="!isBtnLoading">{{ $t("edit") }}</div>

          <div
            class="flex items-center hover:shadow-mdtext-white flex justify-center items-center hover:shadow-md"
            role="status"
            v-else
          >
            <svg
              width="20"
              height="20"
              fill="currentColor"
              class="mr-2 animate-spin"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"
              ></path>
            </svg>
            <span class="mx-1"> {{ $t("wait") }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <DynamicModalAction ref="actionModal"
    ><div class="relative w-full max-w-2xl max-h-full">
      <!-- Modal content -->
      <div class="relative">
        <!-- Modal header -->
        <div class="flex items-start justify-between p-4">
          <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
            {{ $t("change_money_counter") }}
          </h3>
          <i
            class="fa-solid fa-trash text-red-500"
            @click="recivedMoney = 0"
          ></i>
        </div>
        <!-- Modal body -->
        <div class="p-2 mb-14 md:mb-80 text-textBlack1 dark:text-white">
          <p>{{ $t("1_dollar_price") }} = {{ formatNumber(getDolarPrice) }}</p>
          <div class="md:flex w-full mt-2 rounded-lg">
            <div
              class="w-11/12 md:w-7/12 h-20 grid grid-cols-2 gap-x-2 gap-y-4 mx-auto"
            >
              <div
                class="flex flex-col bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(2, 1)"
              >
                <img
                  src="../../assets/image/1_dolar.jpg"
                  alt=""
                  class="w-full h-3/4 rounded-lg curser-pointer"
                />
                <p class="text-center my-auto curser-pointer">
                  {{ $t("1_dollar") }}
                </p>
              </div>
              <div
                class="flex flex-col bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(2, 5)"
              >
                <img
                  src="../../assets/image/5_dolar.png"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("5_dollar") }}</p>
              </div>
              <div
                class="flex flex-col m-1 bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(2, 50)"
              >
                <img
                  src="../../assets/image/50dollar.jpeg"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("50_dollar") }}</p>
              </div>
              <div
                class="flex m-1 flex-col bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(2, 100)"
              >
                <img
                  src="../../assets/image/100dollar.jpg"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("100_dollar") }}</p>
              </div>
              <div
                class="flex flex-col m-1 bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(1, 1000)"
              >
                <img
                  src="../../assets/image/1_iqd.jpg"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("1_thousand_dinar") }}</p>
              </div>
              <div
                class="flex flex-col m-1 bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(1, 5000)"
              >
                <img
                  src="../../assets/image/5dinnar.png"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("5_thousand_dinar") }}</p>
              </div>
              <div
                class="flex flex-col m-1 bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(1, 10000)"
              >
                <img
                  src="../../assets/image/10dinnar.jpg"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("10_thousand_dinar") }}</p>
              </div>
              <div
                class="flex flex-col m-1 bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(1, 25000)"
              >
                <img
                  src="../../assets/image/25dinnar.jpg"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("25_thousand_dinar") }}</p>
              </div>
              <div
                class="flex flex-col m-1 bg-slate-100 dark:bg-bgMeduimDark rounded-lg w-36 h-24 md:w-40 md:h-28 shadow-md"
                @click="addRecievedMoney(1, 50000)"
              >
                <img
                  src="../../assets/image/50dinnar.png"
                  alt=""
                  class="w-full h-3/4 rounded-lg"
                />
                <p class="text-center my-auto">{{ $t("50_thousand_dinar") }}</p>
              </div>
            </div>
            <div class="h-40 md:mt-0"></div>
            <div class="w-full md:w-5/12 h-20 mt-96 md:mt-0">
              <div class="flex mb-2 justify-between">
                <span class="my-auto">{{ $t("items_price") }}</span>
                <input
                  type="number"
                  class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-3/5 p-1.5 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  v-model="in_paid"
                />
              </div>

              <div class="flex mb-2 justify-between">
                <span class="my-auto">{{ $t("money_amount_received") }}</span>
                <input
                  type="number"
                  class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-3/5 p-1.5 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  v-model="recivedMoney"
                />
              </div>

              <div class="flex mb-2 justify-between">
                <span class="my-auto">{{ $t("change_money") }} </span>
                <div class="w-2"></div>
                <input
                  type="number"
                  class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-3/5 p-1.5 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  v-model="getChangeMoney"
                />
              </div>
            </div>
          </div>
        </div>
      </div></div
  ></DynamicModalAction>
  <div :class="classesPrintModal()">
    <!-- modal -->
    <div class="my_font bg-white rounded shadow-lg w-10/12 md:w-1/3">
      <!-- modal body -->
      <div
        class="p-3 bg-white my_font font-bold text-size-base text-black"
        id="invoice_print"
      >
        <div>
          <h6 class="text-center text-black font-bold text-size-lg">
            {{ settings.app_name }}
          </h6>
          <p class="my_font text-center font-bold text-size-base text-black">
            {{ settings.set_header_invoice }}
          </p>
          <p class="my_font text-center font-bold text-size-base text-black">
            <i
              class="fas fa-phone text-size-base relative mx-2 text-pink text-center"
            ></i>
            {{
              settings.set_phone_number +
              (settings.set_phone_number2 != "" &&
              settings.set_phone_number2 != null
                ? " - " + settings.set_phone_number2
                : "")
            }}
          </p>

          <p class="my_font text-center font-bold text-size-base text-black">
            <i
              class="fas fa-map-marker-alt text-size-base relative mx-2 text-pink text-center"
            ></i>
            {{ settings.set_address }}
          </p>
        </div>
        <div class="w-full max-w-full shrink-0 md:w-full md:flex-0 bg-white">
          <div class="flex-auto pb-2 my_font">
            <div class="overflow-x-auto">
              <table
                class="items-center w-full mb-0 align-top border-gray-200 text-black-500"
              >
                <tbody>
                  <tr v-if="in_id != ''">
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("invoice_id") }}
                    </td>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ in_id }}
                    </td>
                  </tr>
                  <tr v-if="cu_id != ''">
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("customer_name") }}
                    </td>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ (selectedCustomer ? selectedCustomer.cu_name : $t("walk_in_customer")) + " - " + cu_id }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("date") }}
                    </td>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      <!--
                                            show index of item in loop 1,2,3,4,5,6,7,8,9,10
                                          -->
                      <div class="whitespace-normal">
                        {{ formatDate(created_at) }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="flex-auto pb-2">
            <div class="overflow-x-auto">
              <table
                class="items-center w-full mb-0 align-top border-gray-200 text-black-500"
              >
                <thead class="align-bottom text-center">
                  <tr>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      #
                    </th>

                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      colspan="3"
                    >
                      {{ $t("item_name") }}
                    </th>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("price") }}
                    </th>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("quantity") }}
                    </th>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      v-if="totalBonusItems > 0"
                    >
                      {{ $t("bonus") }}
                    </th>

                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      v-if="sumDiscount > 0"
                    >
                      {{ $t("discount") }}
                    </th>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("total_price") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="w-full"
                    v-for="(item, index) in getSoldListByCurrentCurrency"
                    :key="index"
                  >
                    <td
                      class="text-black -bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ index + 1 }}
                    </td>

                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-normal dark:border-white/40"
                      colspan="3"
                    >
                      <div class="whitespace-normal">
                        {{ getItemNameWithSize(item) }}
                      </div>
                    </td>
                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ formatNumber(getPriceByUnit(item)) }}
                    </td>
                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ formatNumber(getDisplayQuantity(item)) }}
                    </td>
                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      v-if="totalBonusItems > 0"
                    >
                      {{ item.si_bonus_quantity > 0 ? formatNumber(getDisplayBonusQuantity(item)) : '-' }}
                    </td>
                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      v-if="sumDiscount > 0"
                    >
                      {{ formatNumber(item.si_discount) }}
                    </td>
                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      colspan="1"
                    >
                      {{
                        formatNumber(
                          getItemPrice(item) -
                            item.si_discount
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div>
          <table
            class="items-center w-full mb-0 align-top border-gray-200 text-black-500"
          >
            <tbody>
              <tr>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b>{{ $t("items_price") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <p>
                    {{ formatNumber(sumPriceWithoutDiscount) }}
                  </p>
                </td>
              </tr>
              <tr v-if="sumDiscount > 0">
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b>{{ $t("discount") }} </b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <p>{{ formatNumber(sumDiscount) }}</p>
                </td>
              </tr>

              <!--end tr-->
              <tr>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b>{{ $t("final_price") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-lg my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ formatNumber(sumPrice) }}</b>
                </td>
              </tr>
              <tr v-if="getInDue > 0">
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b>{{ $t("debt") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-lg my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ formatNumber(getInDue) }}</b>
                </td>
              </tr>
              <tr v-if="getInDue > 0">
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b>{{ $t("paid_money") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-lg my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ formatNumber(in_paid) }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="border-b w-full"></div>
      <div class="flex justify-start items-center w-full p-3 bg-white">
        <button
          class="mx-auto text-center bg-pink-600 hover:bg-pink-700 px-3 py-1 rounded text-white"
          @click="modalPrintID"
        >
          <svg
            aria-hidden="true"
            class="mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-pink-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="loading"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span v-if="!loading"> {{ $t("print") }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Calculator Modal -->
  <CalculatorModal
    :isOpen="isCalculatorOpen"
    @close="closeCalculator"
    @open-calculator="openCalculator"
  />
</template>
<script>
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { FILE_URL } from "../../constants/config";
import { CURRENCYS } from "../../constants/config";
import { formatNumber } from "../../utils/functions";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import DynamicModalAction from "../../components/Modals/DynamicModalAction.vue";
import LoadingProgress from "../../components/loading-progress.vue";
import CalculatorModal from "../../components/Modals/CalculatorModal.vue";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    BaseInput,
    ConfirmDialogue,
    ResultDialog,
    TextAreaInput,
    DropdownInput,
    DynamicModalAction,
    LoadingProgress,
    CalculatorModal,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value || value == 0) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      no_rule: [],
      inputType: "text",

      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      isShowDetail: false,
      file_url: FILE_URL,
      currencys: CURRENCYS,
      sold_list: [],
      barcode: "",
      in_paid: 0,
      in_price: 0,
      in_discount: 0,
      in_due: 0,
      total_discount: 0,
      percentage_discount: 0,
      cu_id: "",
      bo_id: "",
      cur_id: 2,
      st_id: "",
      in_main_currency_price: 0,
      pl_id: "",
      in_note: "",
      created_at: "",
      tempItem: 0,
      recivedMoney: 0,
      changeMoney: 0,
      in_id: 0,
      in_status: 1,
      name: "",
      isModalPrint: false,
      settings: {},
      isShowCost: "2",
      isPrintLoading: false,
      invoiceIdList: [],
      invoiceType: 1,
      isShowItemsCategorys: true,
      hasUnsavedChanges: false,
      initialInvoiceState: null,
    };
  },
  created() {
    this.settings = JSON.parse(
      localStorage.getItem("currentSettingWiseManager")
    );

    this.getSaleTypes();
    this.getBoxs();
    this.$store.dispatch("item_category/getCategory");
    this.getCurrentInvoice();
    this.getCustomers();

    this.getPlatforms();

    // Calculate initial total discount after data is loaded
    this.$nextTick(() => {
      setTimeout(() => {
        this.calculateInitialTotalDiscount();
      }, 500);
    });
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.edit_sale.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.edit_sale.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("edit_sale/SET_DELETE_SUCCESS", false);
      }
    },
    sold_list: {
      handler() {
        // Update total discount when sold_list changes
        this.calculateInitialTotalDiscount();
        // Mark as having unsaved changes
        if (this.initialInvoiceState !== null) {
          this.hasUnsavedChanges = true;
        }
      },
      deep: true,
    },
    in_paid() {
      if (this.initialInvoiceState !== null) {
        this.hasUnsavedChanges = true;
      }
    },
    cu_id() {
      if (this.initialInvoiceState !== null) {
        this.hasUnsavedChanges = true;
      }
    },
    st_id() {
      if (this.initialInvoiceState !== null) {
        this.hasUnsavedChanges = true;
      }
    },
    pl_id() {
      if (this.initialInvoiceState !== null) {
        this.hasUnsavedChanges = true;
      }
    },
    in_note() {
      if (this.initialInvoiceState !== null) {
        this.hasUnsavedChanges = true;
      }
    },
    isCalculatorOpen: false,
    async "$route.params.id"(newId) {
      if (!newId) return;
      // Ensure full-page loader shows during data fetch on every navigation
      this.$store.state.loading = true;
      try {
        await this.buildInvoiceIdList();
        await this.getCurrentInvoice();
      } finally {
        this.$store.state.loading = false;
      }
    },
  },

  computed: {
    getChangeMoney() {
      return this.recivedMoney - this.in_paid;
    },
    getInDue() {
      return this.sumPrice - this.in_paid;
    },
    getResultDialog() {
      return this.$store.state.edit_sale.isShowResultDialog;
    },
    getDolarPrice() {
      return this.in_main_currency_price;
    },

    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.edit_sale.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.edit_sale.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.edit_sale.isBtnEditLoading;
    },

    convertToListIdValueCategory() {
      var categorys = this.$store.state.item_category.categorys;
      var list = [];
      for (const item of categorys) {
        list.push({
          id: item.ca_id,
          value: item.ca_name,
        });
      }

      return list;
    },
    convertToListIdValueBoxes() {
      var boxes = this.$store.state.all_box.boxes;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.bo_id,
          value: item.bo_name,
        });
      }

      return list;
    },
    convertToListIdValueSaleTypes() {
      var saleTypes = this.$store.state.sale_type.saleTypes;
      var list = [];
      for (const item of saleTypes) {
        list.push({
          id: item.st_id,
          value: item.st_name,
        });
      }

      return list;
    },
    convertToListIdValuePlatforms() {
      var platforms = this.$store.state.sale_platform.platforms;
      var list = [];
      for (const item of platforms) {
        list.push({
          id: item.pl_id,
          value: item.pl_name,
        });
      }

      return list;
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    sumPriceWithoutDiscount() {
      var sum = 0;
      for (const item of this.getSoldListByCurrentCurrency) {
        sum += this.getItemPrice(item);
      }
      return Math.round(sum).toFixed(0);
    },
    convertToListIdValueCustomers() {
      var customers = this.$store.state.customer.customers;
      var list = [];
      for (const item of customers) {
        list.push({
          id: item.cu_id,
          value: item.cu_name,
        });
      }

      return list;
    },
    selectedCustomer() {
      if (!this.cu_id) return null;
      var customers = this.$store.state.customer.customers;
      return customers.find(customer => customer.cu_id == this.cu_id) || null;
    },
    sumDiscount() {
      var sum = 0;
      for (const item of this.getSoldListByCurrentCurrency) {
        sum += item.si_discount;
      }
      return Math.round(sum);
    },
    //sum price of all items
    sumPrice() {
      var sum = 0;
      for (const item of this.getSoldListByCurrentCurrency) {
        sum += this.getItemPrice(item) - item.si_discount;
      }

      // Round to whole number
      const roundedSum = Math.round(sum);

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //  this.in_paid = sum.toFixed(2);
      return roundedSum.toFixed(0);
    },
    sumCost() {
      var sum = 0;
      for (const item of this.getSoldListByCurrentCurrency) {
        sum += this.getCostPriceByUnit(item) * item.si_quantity;
      }
      return sum.toFixed(2);
    },
    totalBonusItems() {
      var sum = 0;
      for (const item of this.getSoldListByCurrentCurrency) {
        sum += item.si_bonus_quantity || 0;
      }
      return sum;
    },
    hasItemsWithPackages() {
      return this.getSoldListByCurrentCurrency.some(item => 
        item.item && item.item.i_packages && item.item.i_packages.length > 0
      );
    },
    getSoldListByCurrentCurrency() {
      var list = [];
      for (const item of this.sold_list) {
        //cehck this.cur_id == item.cur_id nothing to do otherwise convert price if this.cur_id==1 convert to dinar if this.cur_id==2 convert to dollar

        list.push(item);
      }

      return list;
    },
    filterItemsPos() {
      return this.$store.getters["sale_pos/filterItemsPOS"];
    },
    checkIfEdit() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
    isLastInvoice() {
      const currentId = parseInt(this.$route.params.id || this.in_id);
      if (!this.invoiceIdList || !this.invoiceIdList.length) return false;
      const maxId = this.invoiceIdList[this.invoiceIdList.length - 1];
      return currentId === maxId;
    },
  },

  methods: {
    handleSearchInput(value) {
      this.$store.commit('sale_pos/SET_SEARCH_POS', value);
    },
    getPosData() {
      this.$store.dispatch("sale_pos/getItemsPOS", {
        in_type: this.invoiceType,
      });
    },
    async buildInvoiceIdList() {
      try {
        const tempObj = { page: 1, rowsPerPage: 1000 };
        tempObj.search = "";
        tempObj.searchBarcode = "";
        const res = await this.$store.dispatch("sold_list/getItems", tempObj);
        if (res && res.data && Array.isArray(res.data.data)) {
          this.invoiceIdList = res.data.data
            .map((x) => x.in_id)
            .sort((a, b) => a - b);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async goToPrevInvoice() {
      // show full page loading immediately
      this.$store.state.loading = true;
      if (!this.invoiceIdList.length) {
        await this.buildInvoiceIdList();
      }
      const currentId = parseInt(this.$route.params.id || this.in_id);
      const idx = this.invoiceIdList.indexOf(currentId);
      if (idx > 0) {
        const targetId = this.invoiceIdList[idx - 1];
        this.$router.push({ name: "EditSale", params: { id: targetId } });
      }
    },
    async goToNextInvoice() {
      if (!this.invoiceIdList.length) {
        await this.buildInvoiceIdList();
      }
      // prevent infinite loading if already last
      if (this.isLastInvoice) return;
      // show full page loading only if navigation will happen
      this.$store.state.loading = true;
      const currentId = parseInt(this.$route.params.id || this.in_id);
      const idx = this.invoiceIdList.indexOf(currentId);
      if (idx >= 0 && idx < this.invoiceIdList.length - 1) {
        const targetId = this.invoiceIdList[idx + 1];
        this.$router.push({ name: "EditSale", params: { id: targetId } });
      }
    },
    openCalculator() {
      this.isCalculatorOpen = true;
      this.$nextTick(() => {
        // Force re-render if needed
        this.$forceUpdate();
      });
    },
    closeCalculator() {
      this.isCalculatorOpen = false;
      this.$nextTick(() => {
        // Force re-render if needed
        this.$forceUpdate();
      });
    },
    getSuplierName(su_id) {
      var supliers = this.$store.state.suplier.supliers;
      for (const item of supliers) {
        if (item.su_id == su_id) {
          return item.su_name;
        }
      }
    },
    //getCustomerName
    getCustomerName(cu_id1) {
      var customers = this.$store.state.customer.customers;

      for (const item of customers) {
        if (item.cu_id == cu_id1) {
          return item.cu_name;
        }
      }
      return this.$t("walk_in_customer");
    },
    //costStatus
    costStatus() {},
    modalPrintID() {
      this.isModalPrint = !this.isModalPrint;

      const printContents = document.getElementById("invoice_print").innerHTML;

      // Create a temporary print container
      const printContainer = document.createElement("div");
      printContainer.id = "print-container";
      printContainer.innerHTML = printContents;
      printContainer.style.position = "fixed";
      printContainer.style.left = "-9999px";

      // Hide the main app content
      const appContent = document.getElementById("app"); // Replace with your root element
      appContent.style.visibility = "hidden";

      // Append the print container
      document.body.appendChild(printContainer);

      // Print and clean up
      setTimeout(() => {
        window.print();

        // Restore the original content
        document.body.removeChild(printContainer);
        appContent.style.visibility = "visible";

        this.isModalPrint = !this.isModalPrint;
      }, 500);
    },

    async modalPrintIDA4() {
      this.isPrintLoading = true;
      //call getCurrentDebt(cu_id) from customer.js await for result
      var res = await this.$store.dispatch("customer/getCurrentDebt", {
        cu_id: this.cu_id,
        //invoice date
        created_at: this.created_at,
      });

      var beforeDebtIQD = res.balance_before_date.IQD;
      var beforeDebtUSD = res.balance_before_date.USD;
      //balance_up_to_and_including_date
      var balanceUpToAndIncludingDateIQD =
        res.balance_up_to_and_including_date.IQD;
      var balanceUpToAndIncludingDateUSD =
        res.balance_up_to_and_including_date.USD;

      // Create a hidden iframe for printing
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";

      document.body.appendChild(iframe);

      const invoiceContent = `
    <html>
    <head>
      <title>${this.$t("invoice_title")}</title>
      <style>
        /* Define the Kurdish font and apply it to the body */
        @font-face {
          font-family: 'kurd';
          src: url('https://storage.wisesale.app/Rabar_022-Busi21Jx.ttf') format('truetype');
        }

        body {
          font-family: 'kurd', sans-serif;
          direction: rtl; /* Set text direction to right-to-left */
          text-align: right;
        
          -webkit-print-color-adjust: exact; /* Force printing of background colors */
          print-color-adjust: exact;
          background: white;
          margin: 0;
        }

        /* Set A4 dimensions and margins for print */
        @page {
          size: A4;
         
        }
        
        .my_font { font-family: 'kurd' !important; }

        /* General styles for the invoice layout */
        .invoice-container {
          max-width: 210mm;
          margin: 0 auto;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          padding: 10mm;
        }

        /* Header styles */
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 20px;
          
        }
          .headerBorder{
          border-bottom: 2px solid #eee;}
        .header h1 {
          font-size: 28px;
          color: #7165E3;
          margin: 0;
        }
        .header p {
          margin: 0;
          font-size: 12px;
          color: #777;
        }
        .header .company-info {
          text-align: right;
        }

        /* Details section styles */
        .details {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          font-size: 13px;
        }
        .details h3 {
          margin: 0 0 5px 0;
          font-size: 15px;
          color: #7165E3;
        }

        /* Table styles */
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #eee;
          padding: 10px;
          text-align: center;
        }
        th {
          background-color: #7165E3;
          color: white;
        }
        tr:nth-child(even) {
          background-color: #f9f9f9;
        }
        
        /* Summary styles */
        .summary-box {
          margin-top: 20px;
          background: #f2f2f2;
          padding: 10px;
          border-radius: 5px;
        }
        .summary-box h3 {
          margin: 5px 0;
          color: #7165E3;
        }
 .summary-box1 h3 {
          margin: 1px 0;
          color: #7165E3;
        }
        /* Footer styles */
        .footer {
          margin-top: 40px;
          text-align: center;
          font-size: 14px;
        }
      </style>
    </head>
    <body>
      <div class="invoice-container">
        <!-- HEADER -->
        <div class="header headerBorder">
          <div class="company-info">
            <h1>${this.settings.app_name}</h1>
       
            
            <p>${this.$t("phone number")}: ${
        this.settings.set_phone_number +
        (this.settings.set_phone_number2 != "" &&
        this.settings.set_phone_number2 != null
          ? " - " + this.settings.set_phone_number2
          : "")
      }</p>
                 <p>${this.$t("address")}: ${this.settings.set_address}</p>
          </div>
          <div class="company-logo">
            <img
              src="${this.file_url + this.settings.set_logo}"
              alt="Company Logo"
              style="max-width: 100px; max-height: 100px;"
            />
          </div>
          <div>
            <h1 style="color: #333; font-size: 20px;">${this.$t(
              this.settings.set_header_invoice
            )}</h1>
            <p><strong>${this.$t("invoice_id")}:</strong> ${
        this.in_id || "-"
      }</p>
            <p><strong>${this.$t("date")}:</strong> ${formatDate(
        this.created_at
      )}</p>
          </div>
        </div>  <div class="header">
<h2 style="color: #333; font-size: 18px;">${
        this.$t("customer_name") +
        " : " +
        this.cu_id +
        " - " +
        (this.selectedCustomer ? this.selectedCustomer.cu_name : this.$t("walk_in_customer"))
      }</h2>
      ${
        this.in_status != 1
          ? `  <p style="color: red; font-size: 16px; font-weight: bold;" v-if="in_status == 0">
        ${this.$t("returned")}
      </p>`
          : ""
      }
    
</div>
        <!-- LINE ITEMS TABLE -->
        <table>
          <thead>
            <tr>   <th>${this.$t("#")}</th>
              <th>${this.$t("item_name")}</th>
              <th>${this.$t("price_dana")}</th>
              <th>${this.$t("quantity")}</th>
              ${this.totalBonusItems > 0 ? `<th>${this.$t("bonus")}</th>` : ``}
              ${this.sumDiscount > 0 ? `<th>${this.$t("discount")}</th>` : ``}
              <th>${this.$t("total_price")}</th>
            </tr>
          </thead>
          <tbody>
            ${this.getSoldListByCurrentCurrency
              .map(
                (item) => `
              <tr>    <td>${
                this.getSoldListByCurrentCurrency.indexOf(item) + 1
              }</td>
                <td>${this.getItemNameWithSize(item)}</td>
                <td>${this.formatNumber(this.getPriceByUnit(item))}</td>
                <td>${this.formatNumber(this.getDisplayQuantity(item))}</td>
                ${
                  this.totalBonusItems > 0
                    ? `<td>${item.si_bonus_quantity > 0 ? this.formatNumber(this.getDisplayBonusQuantity(item)) : '-'}</td>`
                    : ``
                }
                ${
                  this.sumDiscount > 0
                    ? `<td>${this.formatNumber(item.si_discount)}</td>`
                    : ``
                }
                <td>${this.formatNumber(
                  this.getItemPrice(item) -
                    item.si_discount
                )}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
  ${
    this.in_note
      ? `
    <div class="summary-box" style="margin: 10px 0 !important; padding: 8px !important;">
      <h3 style="margin: 0 0 5px 0 !important;">${this.$t("note")}</h3>
      <p style="margin: 0 !important;">${this.in_note}</p>
    </div>
    `
      : ``
  }

        <!-- SUMMARY SECTION -->

        <!-- SUMMARY SECTION -->
        <div class='header'>
        
          ${
            beforeDebtIQD > 0 ||
            beforeDebtIQD < 0 ||
            beforeDebtUSD > 0 ||
            beforeDebtUSD < 0 ||
            balanceUpToAndIncludingDateIQD > 0 ||
            balanceUpToAndIncludingDateIQD < 0 ||
            balanceUpToAndIncludingDateUSD > 0 ||
            balanceUpToAndIncludingDateUSD < 0
              ? `
        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
  <div style="background-color: #f2f2f2; padding: 15px; border-radius: 5px; border: 1px solid #ddd; box-sizing: border-box; min-width: 200px;">
    
    <!-- Balance Before -->
    <div style="padding: 4px 0; ">
      <div style="font-size: 14px; ">
        ${this.$t(
          "balance_before"
        )}: <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(beforeDebtIQD)} ${this.$t("dinar")}
      </div>
      </div>
      
      <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(beforeDebtUSD)} ${this.$t("dollar")}
      </div>
    </div>

    <!-- Balance After -->
    <div style="padding: 4px 0;  margin-top: 10px;">
      <div style="font-size: 14px; ">
        ${this.$t("balance_after")}:
      </div>
      <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(balanceUpToAndIncludingDateIQD)} ${this.$t("dinar")}
      </div>
      <div style="font-size: 14px; font-weight: bold;color: red;">
        ${formatNumber(balanceUpToAndIncludingDateUSD)} ${this.$t("dollar")}
      </div>
    </div>

  </div>
</div>
              `
              : ``
          }
        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <div style="; background-color: #f2f2f2; padding: 15px; border-radius: 5px; border: 1px solid #ddd; box-sizing: border-box;">
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="font-size: 17px; font-weight: normal; color: #555;">${this.$t(
                "items_price"
              )}:</span>
              <span style="font-size: 17px; font-weight: normal; color: #333;">  ${this.formatNumber(
                this.sumPriceWithoutDiscount
              )} ${this.$t(this.cur_id == 1 ? "dinar" : "dollar")}</span>
            </div>
            ${
              this.sumDiscount > 0
                ? `
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="font-size: 17px; font-weight: normal; color: #555;">${this.$t(
                "discount"
              )}:</span>
              <span style="font-size: 17px; font-weight: normal; color: #333;">${formatNumber(
                this.sumDiscount
              )} ${this.$t(this.cur_id == 1 ? "dinar" : "dollar")}</span>
            </div>
            `
                : ``
            }
            <div style="display: flex; justify-content: space-between; padding: 4px 0; font-size: 18px; color: #333;">
              <span style=" color: #555;">${this.$t("final_price")}:</span>
              <span style=" font-weight: bold;">${formatNumber(
                this.sumPrice
              )} ${this.$t(this.cur_id == 1 ? "dinar" : "dollar")}</span>
            </div>
            ${
              this.getInDue > 0
                ? `
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="font-size: 18px; font-weight: normal; color: #555;">${this.$t(
                "paid_money"
              )}:</span>
              <span style="font-size: 18px; font-weight: bold; color: #008000;">${formatNumber(
                this.in_paid
              )} ${this.$t(this.cur_id == 1 ? "dinar" : "dollar")}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 4px 0">
              <span style="font-size: 18px; ; color: #555;">${this.$t(
                "debt"
              )}:</span>
              <span style="font-size: 18px; font-weight: bold;; color: red;">${formatNumber(
                this.getInDue
              )} ${this.$t(this.cur_id == 1 ? "dinar" : "dollar")}</span>
            </div>
            `
                : ``
            }
          </div>
        </div>
        


        </div>
        
        </div>

      </div>
    </body>
    </html>
  `;

      // Write the generated HTML to the iframe
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(invoiceContent);
      doc.close();

      // Wait a moment before printing
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          // Cleanup
        }, 50); // slight delay ensures content is loaded
      };
      this.isPrintLoading = false;
    },

    classesPrintModal() {
      return {
        "modal  bg-opacity-5 h-full   w-full  fixed top-0 left-0  justify-center   hidden overflow-y-auto":
          !this.isModalPrint,
        "modal  bg-opacity-5 h-full   w-full  fixed top-0 left-0  justify-center  flex overflow-y-auto ":
          this.isModalPrint,
      };
    },
    async getCustomers() {
      await this.$store.dispatch("customer/getCustomers");
    },
    async getPlatforms() {
      await this.$store.dispatch("sale_platform/getPlatforms");

      this.pl_id = this.$store.state.sale_platform.platforms[0].pl_id;
    },
    async getCurrentInvoice() {
      this.in_id = this.$route.params.id;
      var res = await this.$store.dispatch("edit_sale/getCurrentInvoice", {
        in_id: this.$route.params.id,
      });
      //check status

      if (res.status == 200) {
        // Separate paid items (price > 0) from free items (price == 0) that weren't combined by backend
        const paidItems = [];
        const freeItems = [];
        
        res.data.invoice_items.forEach(item => {
          // Only treat as free item if price is 0 AND it's a separate row (not already combined)
          // Backend combines free items, so if si_bonus_quantity > 0, it's already combined
          if ((item.si_sale_price == 0 || item.si_sale_price === null) && (item.si_quantity || 0) > 0) {
            freeItems.push(item);
          } else {
            paidItems.push(item);
          }
        });
        
        // Process paid items first
        this.sold_list = paidItems.map(item => {
          const mappedItem = {
            ...item,
            si_bonus_quantity: item.si_bonus_quantity || 0,
            si_sale_price: item.si_sale_price || 0,
            size_type: item.size_type || null, // Preserve size_type from backend
            si_bottle_size: item.si_bottle_size || null // Preserve si_bottle_size from backend
          };
          
          // Check if si_quantity matches a size value (e.g., 30, 50, 100, 150, 400)
          // If item has i_sizes and si_quantity matches a size, reconstruct selected_size and bottle_quantity
          if (item.item && item.item.i_sizes) {
            let sizes = item.item.i_sizes;
            if (typeof sizes === 'string') {
              try {
                sizes = JSON.parse(sizes);
              } catch (e) {
                sizes = null;
              }
            }
            
            if (sizes && Array.isArray(sizes) && sizes.length > 0) {
              // Use size_type field if available (stored as number like "30", "50", "100" or "none")
              if (item.size_type && item.size_type !== 'none' && item.size_type !== null) {
                const sizeTypeValue = parseFloat(item.size_type) || 0;
                if (sizeTypeValue > 0) {
                  // Find the matching size from i_sizes
                  const matchedSize = sizes.find(size => {
                    if (!size.is_size) return false;
                    const sizeValue = parseFloat(size.is_size.replace(/[^0-9.]/g, '')) || 0;
                    return Math.abs(sizeValue - sizeTypeValue) < 0.01;
                  });
                  
                  if (matchedSize) {
                    mappedItem.selected_size = matchedSize;
                    // Calculate bottle_quantity from si_quantity and size value
                    const sizeValue = parseFloat(matchedSize.is_size.replace(/[^0-9.]/g, '')) || 1;
                    const siQty = item.si_quantity || 0;
                    if (sizeValue > 0) {
                      mappedItem.bottle_quantity = Math.round(siQty / sizeValue);
                    } else {
                      mappedItem.bottle_quantity = 1;
                    }
                  }
                }
              } else {
                // Fallback: Try to determine size by dividing si_quantity by known sizes (30, 50, 100 ml)
                const siQty = item.si_quantity || 0;
                
                // Extract all size values and sort them in descending order (largest first)
                const sizeValues = sizes
                  .filter(size => size.is_size)
                  .map(size => {
                    const sizeValue = parseFloat(size.is_size.replace(/[^0-9.]/g, '')) || 0;
                    return { size, sizeValue };
                  })
                  .filter(item => item.sizeValue > 0)
                  .sort((a, b) => b.sizeValue - a.sizeValue); // Sort descending
                
                // Try to find the best matching size by dividing si_quantity by each size
                let bestMatch = null;
                let bestBottles = 0;
                let minRemainder = Infinity;
                
                for (const { size, sizeValue } of sizeValues) {
                  const bottles = siQty / sizeValue;
                  const remainder = Math.abs(bottles - Math.round(bottles));
                  
                  // Prefer matches where bottles is a whole number or close to whole number
                  // Also prefer larger sizes if there's a tie (e.g., 100ml over 50ml for 100ml quantity)
                  if (remainder < minRemainder || (remainder === minRemainder && sizeValue > (bestMatch?.sizeValue || 0))) {
                    minRemainder = remainder;
                    bestMatch = { size, sizeValue };
                    bestBottles = Math.round(bottles);
                  }
                }
                
                // Only match if we found a reasonable match (bottles >= 1 and remainder is small)
                if (bestMatch && bestBottles >= 1 && minRemainder < 0.1) {
                  // This is a size-based item
                  mappedItem.selected_size = bestMatch.size;
                  mappedItem.bottle_quantity = bestBottles;
                }
              }
            }
          }
          
          return mappedItem;
        });
        
        // Now combine free items with matching paid items
        freeItems.forEach(freeItem => {
          // Find matching paid item (same i_id, same size_type or si_bottle_size)
          const matchingPaidItem = this.sold_list.find(paidItem => {
            if (paidItem.i_id !== freeItem.i_id) return false;
            
            // Try to match by size_type first (preferred method)
            const paidSizeType = paidItem.size_type || null;
            const freeSizeType = freeItem.size_type || null;
            
            if (paidSizeType && freeSizeType && paidSizeType !== 'none' && freeSizeType !== 'none') {
              return paidSizeType === freeSizeType;
            }
            
            // Fallback: match by si_bottle_size (what backend uses)
            const paidBottleSize = paidItem.si_bottle_size || null;
            const freeBottleSize = freeItem.si_bottle_size || null;
            
            if (paidBottleSize && freeBottleSize) {
              return paidBottleSize === freeBottleSize;
            }
            
            // If neither has size info, they match (regular items)
            if (!paidSizeType && !freeSizeType && !paidBottleSize && !freeBottleSize) {
              return true;
            }
            
            // If one has size and the other doesn't, they don't match
            return false;
          });
          
          if (matchingPaidItem) {
            // Add free item's quantity to bonus quantity
            // Backend stores si_bonus_quantity in ML (same unit as si_quantity), so add si_quantity directly
            matchingPaidItem.si_bonus_quantity = (matchingPaidItem.si_bonus_quantity || 0) + (freeItem.si_quantity || 0);
          }
          // If no matching paid item found, the free item is ignored (not shown as a separate row)
        });
        
        //loop through sold_list and add some properties

        this.in_paid = res.data.in_paid;

        this.in_price = res.data.in_price;
        this.in_discount = res.data.in_discount;
        this.in_due = res.data.in_due;
        this.cu_id = res.data.cu_id;
        this.bo_id = res.data.bo_id;
        this.cur_id = res.data.cur_id;
        this.st_id = res.data.st_id;
        this.in_main_currency_price = res.data.in_main_currency_price;
        this.pl_id = res.data.pl_id;
        this.in_note = res.data.in_note;
        this.created_at = res.data.created_at;

        this.in_status = res.data.in_status;
        this.name = res.data.users.name;
        this.invoiceType = res.data.in_type;
        this.getPosData();
        
        // Save initial state after loading - use nextTick to ensure data is settled
        this.$nextTick(() => {
          this.initialInvoiceState = JSON.stringify({
            sold_list: this.sold_list,
            in_paid: this.in_paid,
            cu_id: this.cu_id,
            st_id: this.st_id,
            pl_id: this.pl_id,
            in_note: this.in_note,
          });
          this.hasUnsavedChanges = false;
        });
      } else {
        //route to 404
        this.$router.push({ name: "NotFound" });
      }
    },
    changeCurrencyType() {
      if (this.cur_id == 1) {
        this.cur_id = 2;
      } else {
        this.cur_id = 1;
      }
    },
    getUnit(item) {
      return item.item.unit.un_name;
    },
    getPriceByUnit(item) {
      // Check if item has packages and calculate package-based pricing
      if (item.item && item.item.i_packages && item.item.i_packages.length > 0) {
        const quantity = (item.selected_size && item.bottle_quantity !== undefined) ? item.bottle_quantity : item.si_quantity;
        return this.calculatePackagePrice(item.item, quantity);
      }

      // For size items, si_sale_price is stored as price per ML
      // Multiply by size value to get price per bottle for display
      if (item.selected_size && item.selected_size.is_size) {
        const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 1;
        return item.si_sale_price * sizeValue; // Price per bottle = price per ML * size value
      }

      // Fallback to regular price (already per unit)
      return item.si_sale_price;
    },
    getItemPrice(item) {
      // For size items, use bottle_quantity instead of si_quantity
      if (item.selected_size && item.bottle_quantity !== undefined) {
        return item.bottle_quantity * this.getPriceByUnit(item);
      }
      // For regular items, use si_quantity
      return item.si_quantity * this.getPriceByUnit(item);
    },
    getDisplayQuantity(item) {
      // For size items, show bottle_quantity (number of bottles)
      if (item.selected_size && item.selected_size.is_size) {
        // If bottle_quantity is set, use it
        if (item.bottle_quantity !== undefined && item.bottle_quantity !== null) {
          return item.bottle_quantity;
        }
        // Otherwise, calculate from si_quantity and size value
        const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 0;
        if (sizeValue > 0 && item.si_quantity) {
          return Math.round(item.si_quantity / sizeValue);
        }
        // Fallback to 1 if calculation fails
        return 1;
      }
      // For regular items, show si_quantity
      return item.si_quantity;
    },
    getDisplayBonusQuantity(item) {
      // For size items, si_bonus_quantity is in ML, convert to bottles
      if (item.selected_size && item.selected_size.is_size) {
        const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 0;
        if (sizeValue > 0 && item.si_bonus_quantity > 0) {
          return Math.round(item.si_bonus_quantity / sizeValue);
        }
      }
      // For regular items, show si_bonus_quantity directly
      return item.si_bonus_quantity || 0;
    },
    getItemNameWithSize(item) {
      // Get item name - handle both item.item.i_name and item.i_name structures
      const itemName = item.item ? item.item.i_name : item.i_name;
      
      // If item has a selected size, append it to the name
      if (item.selected_size && item.selected_size.is_size) {
        return `${itemName} ${item.selected_size.is_size}`;
      }
      // For regular items, return name as is
      return itemName;
    },
    updateBonusQuantity(item, event) {
      // Update bonus quantity - for size items, convert bottles to ML for storage
      let bonusBottles = parseFloat(event.target.value) || 0;
      if (bonusBottles < 0) bonusBottles = 0;
      
      if (item.selected_size && item.selected_size.is_size) {
        // Convert bottle quantity to ML for storage
        const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 0;
        if (sizeValue > 0) {
          item.si_bonus_quantity = Math.round(bonusBottles * sizeValue);
        } else {
          item.si_bonus_quantity = bonusBottles;
        }
      } else {
        // Regular item - store directly
        item.si_bonus_quantity = bonusBottles;
      }
      // Trigger reactivity
      this.sold_list = [...this.sold_list];
      // Recalculate discounts
      this.recalculateDiscounts();
    },
    updateSizeItemPrice(item, event) {
      // Convert price per bottle back to price per ML
      let pricePerBottle = parseFloat(event.target.value) || 0;
      
      // Format based on currency: IQD (cur_id == 1) = whole number, Dollar (cur_id == 2) = 2 decimals
      const itemCurrencyId = item.cur_id || this.cur_id;
      if (itemCurrencyId == 1) {
        // IQD: Round to whole number
        pricePerBottle = Math.round(pricePerBottle);
      } else {
        // Dollar: Round to 2 decimal places
        pricePerBottle = Math.round(pricePerBottle * 100) / 100;
      }
      
      if (item.selected_size && item.selected_size.is_size) {
        const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 1;
        if (sizeValue > 0) {
          item.si_sale_price = pricePerBottle / sizeValue; // Store as price per ML
        } else {
          item.si_sale_price = pricePerBottle;
        }
      } else {
        item.si_sale_price = pricePerBottle;
      }
      // Trigger reactivity
      this.sold_list = [...this.sold_list];
      // Recalculate discounts
      this.recalculateDiscounts();
    },
    formatPriceForInput(item) {
      // Format price for input field based on currency
      const price = item.selected_size && item.selected_size.is_size 
        ? this.getPriceByUnit(item) 
        : item.si_sale_price;
      const itemCurrencyId = item.cur_id || this.cur_id;
      
      if (itemCurrencyId == 1) {
        // IQD: Round to whole number (remove decimals) - use toFixed(0) to remove all decimals
        return parseFloat(Math.round(price).toFixed(0));
      } else {
        // Dollar: Round to 2 decimal places
        return parseFloat((Math.round(price * 100) / 100).toFixed(2));
      }
    },
    updateRegularItemPrice(item, event) {
      // Update price for regular items (non-size items)
      let newPrice = parseFloat(event.target.value) || 0;
      
      // Format based on currency: IQD (cur_id == 1) = whole number, Dollar (cur_id == 2) = 2 decimals
      const itemCurrencyId = item.cur_id || this.cur_id;
      if (itemCurrencyId == 1) {
        // IQD: Round to whole number
        newPrice = Math.round(newPrice);
      } else {
        // Dollar: Round to 2 decimal places
        newPrice = Math.round(newPrice * 100) / 100;
      }
      
      item.si_sale_price = newPrice;
      // Trigger reactivity
      this.sold_list = [...this.sold_list];
      // Recalculate discounts
      this.recalculateDiscounts();
    },
    
    calculatePackagePrice(item, quantity) {
      // If no packages defined, return the regular price
      if (!item.i_packages || item.i_packages.length === 0) {
        return item.i_sale_price;
      }
      
      // Sort packages by quantity (descending) to find the best match
      const packages = [...item.i_packages].sort((a, b) => b.quantity - a.quantity);
      
      // Find the first package that matches the quantity
      for (const pkg of packages) {
        if (quantity >= pkg.quantity) {
          return pkg.price;
        }
      }
      
      // If no package matches, return the original item price (i_sale_price)
      // This ensures we go back to the base price when quantity is below all package thresholds
      return item.i_sale_price;
    },
    getCostPriceByUnit(item) {
      return item.si_cost_price;
    },
    async getBoxs() {
      await this.$store.dispatch("all_box/getBoxes");

      this.bo_id = this.$store.state.all_box.boxes[0].bo_id;
    },
    async getSaleTypes() {
      await this.$store.dispatch("sale_type/getSaleTypes");

      this.st_id = this.$store.state.sale_type.saleTypes[0].st_id;
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    formatDate(date) {
      return formatDate(date);
    },
    calculateDue(item, num) {
      this.updateInvoice(item, num);
    },
    setQuantityFromPackage(item, packageQuantity, packagePrice) {
      // Set the quantity to the package quantity and update the price
      // Find the cart item and update it directly
      for (const soldItem of this.sold_list) {
        if (soldItem.i_id == item.i_id) {
          soldItem.si_quantity = packageQuantity;
          // Use the specific package price that was clicked
          soldItem.si_sale_price = packagePrice;
          break;
        }
      }
      
      // Trigger reactivity
      this.sold_list = [...this.sold_list];
      
      // Recalculate discounts
      this.recalculateDiscounts();
    },
    async addSaleItem() {
      //check form validation
      if (this.$store.state.edit_sale.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.st_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.cu_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.pl_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.in_paid, "add", this.rules).isError ||
        this.checkRulesIsError(this.sumPrice, "add", this.rules).isError ||
        this.checkRulesIsError(this.sumDiscount, "add", this.rules).isError ||
        this.checkRulesIsError(this.getInDue, "add", this.rules).isError
      ) {
        this.$refs.ResultDialog.show({
          message: this.$t("please_fill_all_fields"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }
      //check if in paid > in price
      if (this.in_paid > this.sumPrice) {
        this.$refs.ResultDialog.show({
          message: this.$t("paid_money_more_than_total_price"),

          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }
      //check if in_paid or in_price or in_discount or in_due is not number or < 0
      if (
        isNaN(this.in_paid) ||
        isNaN(this.in_price) ||
        isNaN(this.in_discount) ||
        isNaN(this.in_due) ||
        this.in_paid < 0 ||
        this.in_price < 0 ||
        this.in_discount < 0 ||
        this.in_due < 0
      ) {
        this.$refs.ResultDialog.show({
          message: this.$t("please_enter_valid_number_for_all_fields"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }

      if (this.sold_list.length == 0) {
        this.$refs.ResultDialog.show({
          message: this.$t("no_item_in_invoice"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }
      if (this.getInDue > 0) {
        const ok = await this.$refs.confirmDialogue.show({
          message:
            this.$t("are_you_sure_this_invoice_has_due") +
            " " +
            this.formatNumber(this.getInDue) +
            (this.cur_id == 1 ? this.$t("dinar") : this.$t("dollar")) +
            " ?",
          okButton: this.$t("yes"),
          isIcon: false,
          color:
            "bg-blue-600 hover:bg-blue-700 focus:ring-blue-300 dark:bg-blue-500  dark:hover:bg-blue-600 dark:focus:ring-blue-900", // Color of the confirm button
        });
        if (!ok) {
          this.$store.state.edit_sale.isBtnLoading = false;
          return;
        }
      }
      this.$store.state.edit_sale.isBtnLoading = true;
      this.$store.state.sale_pos.isBtnLoading = true;
      var tempSoldList = [];
      for (const item of this.getSoldListByCurrentCurrency) {
        // Calculate price - for size-based items, store price per ML
        let salePrice = item.si_sale_price;
        if (item.selected_size && item.selected_size.is_size) {
          // Price is currently per bottle, convert to per ML
          const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 1;
          if (sizeValue > 0) {
            // If getPriceByUnit returns price per bottle, divide by size to get per ML
            const pricePerBottle = this.getPriceByUnit(item);
            salePrice = pricePerBottle / sizeValue; // Price per ML
          }
        }
        
        // Extract size_type - always derive from selected_size if it exists (most reliable source)
        // If no selected_size, fall back to item.size_type
        let sizeType = null;
        if (item.selected_size && item.selected_size.is_size) {
          // Item has a selected size - extract the numeric value (e.g., "30ml" -> "30")
          const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 0;
          sizeType = sizeValue > 0 ? sizeValue.toString() : null;
        } else if (item.size_type && item.size_type !== 'none' && item.size_type !== null) {
          // Fallback: use existing size_type if no selected_size
          sizeType = item.size_type;
        }
        
        tempSoldList.push({
          i_id: item.i_id,
          i_barcode: item.i_barcode,
          si_quantity: item.si_quantity,
          si_bonus_quantity: item.si_bonus_quantity || 0,
          cur_id: item.cur_id,
          si_sale_price: salePrice, // Price per ML for size items, price per unit for regular items
          si_discount: item.si_discount,
          si_cost_price: item.si_cost_price,
          size_type: sizeType, // Send size_type (e.g., "30", "50", "100" or null for none)
        });
      }

      var res = await this.$store.dispatch("edit_sale/editItem", {
        cu_id: this.cu_id,
        in_id: this.in_id,
        st_id: this.st_id,
        pl_id: this.pl_id,
        in_paid: this.in_paid,
        in_price: this.sumPrice,
        in_cost: this.sumCost,
        in_discount: this.sumDiscount,
        in_due: this.getInDue,
        in_note: this.in_note,
        sold_items: tempSoldList,
        created_at: this.formatDate(this.created_at),
      });
      if (res.status == 200) {
        this.isSubmited = false;
        this.getCurrentInvoice();
        // Reset unsaved changes flag after successful save
        this.hasUnsavedChanges = false;
      }
      this.$store.state.edit_sale.isBtnLoading = false;
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    addRecievedMoney(curency, amount) {
      //check this.cur_id == curency.cur_id
      if (this.cur_id == curency) {
        this.recivedMoney += amount;
      } else {
        if (this.cur_id == 1) {
          //convert to dinar
          this.recivedMoney += amount * this.in_main_currency_price;
        } else {
          //convert to dollar
          this.recivedMoney += amount / this.in_main_currency_price;
        }
      }
    },

    async showModal(item) {
      this.current = item;
      await this.$refs.actionModal.show();
    },
    async addItemToInvoice(item) {
      // Optional expired check
      if (item.i_expire_date != null) {
        const today = new Date();
        const exp = new Date(item.i_expire_date);
        if (exp < today) {
          const ok = await this.$refs.confirmDialogue.show({
            message: this.$t("this_item_is_expired_are_you_sure_want_to_add_it"),
            okButton: this.$t("yes"),
          });
          if (!ok) return;
        }
      }

      // Stock check
      if (item.i_quantity <= 0) {
        this.$refs.ResultDialog.show({
          message: this.$t("this_item_is_not_available"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }

      // Exists in current invoice? increment quantity
      let exists = false;
      for (const soldItem of this.sold_list) {
        if (soldItem.i_id == item.i_id) {
          exists = true;
          // Prevent exceeding available stock if we know it
          const availableQty = soldItem.item && soldItem.item.i_quantity != null
            ? soldItem.item.i_quantity
            : item.i_quantity;
          if (soldItem.si_quantity >= availableQty) {
            this.$refs.ResultDialog.show({
              message: this.$t("not_enough_item_in_stock"),
              okButton: this.$t("done"),
              isSuccess: false,
            });
            return;
          }
          soldItem.si_quantity++;
          // Update price based on new quantity and packages
          soldItem.si_sale_price = this.calculatePackagePrice(item, soldItem.si_quantity);
          break;
        }
      }

      // Add new line if not exists
      if (!exists) {
        const convertedPrice = parseFloat(
          item.cur_id == this.cur_id
            ? item.i_sale_price
            : item.cur_id == 1
            ? item.i_sale_price / this.in_main_currency_price
            : item.i_sale_price * this.in_main_currency_price
        );

        const newItem = {
          i_id: item.i_id,
          i_barcode: item.i_barcode,
          si_quantity: 1,
          si_bonus_quantity: 0,
          cur_id: item.cur_id,
          si_sale_price: parseFloat(convertedPrice.toFixed(2)),
          si_discount: 0,
          si_cost_price: item.i_cost_price,
          item: {
            i_name: item.i_name,
            i_barcode: item.i_barcode,
            i_quantity: item.i_quantity,
            unit: { un_name: item.unit.un_name },
            i_expire_date: item.i_expire_date,
            i_image: item.i_image,
            i_packages: item.i_packages,
            i_sale_price: item.i_sale_price, // Store original price for package calculations
          },
        };
        
        // Calculate package-based price for new items
        newItem.si_sale_price = this.calculatePackagePrice(item, newItem.si_quantity);
        this.sold_list.push(newItem);
      } else {
        // trigger reactivity update after increment
        this.sold_list = [...this.sold_list];
      }

      // Recalculate discounts after adding
      this.recalculateDiscounts();
    },
    updateInvoice(item, num) {
      if (num > item.item.i_quantity) {
        /*this.$refs.ResultDialog.show({
          message: this.$t("not_enough_item_in_stock"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;*/
      }
      for (const soldItem of this.sold_list) {
        if (soldItem.i_id == item.i_id) {
          soldItem.si_quantity = num;
          // Always update price based on quantity and packages
          // Use the cart item's stored original price and packages
          const tempItem = {
            i_sale_price: soldItem.item.i_sale_price,
            i_packages: soldItem.item.i_packages
          };
          soldItem.si_sale_price = this.calculatePackagePrice(tempItem, soldItem.si_quantity);
          break;
        }
      }

      this.sold_list = [...this.sold_list];

      // Recalculate discounts after quantity change
      this.recalculateDiscounts();
    },
    applyTotalDiscount() {
      if (this.sold_list.length === 0) {
        return;
      }

      // Clear percentage discount when using total discount
      this.percentage_discount = 0;

      // If total discount is 0 or negative, clear all item discounts
      if (this.total_discount <= 0) {
        for (const item of this.sold_list) {
          item.si_discount = 0;
        }
        this.sold_list = [...this.sold_list];
        return;
      }

      // Calculate total price without any discounts
      let totalPriceWithoutDiscount = 0;
      for (const item of this.sold_list) {
        totalPriceWithoutDiscount += this.getItemPrice(item);
      }

      if (this.total_discount > totalPriceWithoutDiscount) {
        this.$refs.ResultDialog.show({
          message: this.$t("discount_more_than_total_price"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        this.total_discount = 0;
        return;
      }

      // Distribute the total discount proportionally among items
      let totalCalculatedDiscount = 0;
      for (const item of this.sold_list) {
        const itemPrice = this.getItemPrice(item);
        const proportionalDiscount =
          (itemPrice / totalPriceWithoutDiscount) * this.total_discount;
        item.si_discount = Math.round(proportionalDiscount * 100) / 100; // Round to 2 decimal places
        totalCalculatedDiscount += item.si_discount;
      }

      // Adjust the last item's discount to ensure total discount equals the desired amount
      if (this.sold_list.length > 0) {
        const difference = this.total_discount - totalCalculatedDiscount;
        const lastItem = this.sold_list[this.sold_list.length - 1];
        lastItem.si_discount =
          Math.round((lastItem.si_discount + difference) * 100) / 100;
      }

      this.sold_list = [...this.sold_list];
    },
    applyPercentageDiscount() {
      if (this.sold_list.length === 0) {
        return;
      }

      // Clear total discount when using percentage discount
      this.total_discount = 0;

      // If percentage discount is 0 or negative, clear all item discounts
      if (this.percentage_discount <= 0) {
        for (const item of this.sold_list) {
          item.si_discount = 0;
        }
        this.sold_list = [...this.sold_list];
        return;
      }

      // Validate percentage range
      if (this.percentage_discount > 100) {
        this.$refs.ResultDialog.show({
          message: this.$t("percentage_discount_cannot_exceed_100"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        this.percentage_discount = 0;
        return;
      }

      // Apply percentage discount to each item
      let totalCalculatedDiscount = 0;
      for (const item of this.sold_list) {
        const itemPrice = this.getItemPrice(item);
        const discountAmount = (itemPrice * this.percentage_discount) / 100;
        item.si_discount = Math.round(discountAmount * 100) / 100; // Round to 2 decimal places
        totalCalculatedDiscount += item.si_discount;
      }

      // Round the total discount to a whole number and adjust the last item
      const roundedTotalDiscount = Math.round(totalCalculatedDiscount);
      if (
        this.sold_list.length > 0 &&
        roundedTotalDiscount !== totalCalculatedDiscount
      ) {
        const difference = roundedTotalDiscount - totalCalculatedDiscount;
        const lastItem = this.sold_list[this.sold_list.length - 1];
        lastItem.si_discount =
          Math.round((lastItem.si_discount + difference) * 100) / 100;
      }

      this.sold_list = [...this.sold_list];
    },
    recalculateDiscounts() {
      // Recalculate discounts when cart changes
      if (this.total_discount > 0) {
        this.applyTotalDiscount();
      } else if (this.percentage_discount > 0) {
        this.applyPercentageDiscount();
      }
    },
    calculateInitialTotalDiscount() {
      // Calculate total discount from all items when page loads
      if (this.sold_list.length > 0) {
        let totalDiscount = 0;
        for (const item of this.sold_list) {
          totalDiscount += item.si_discount || 0;
        }
        // Only update if there are actual discounts and we're not in the middle of applying a discount
        if (totalDiscount > 0 && this.percentage_discount === 0) {
          this.total_discount = Math.round(totalDiscount);
        }
      }
    },
    checkHowMuchItemInCard(i_id) {
      let totalBottles = 0;
      for (const item of this.sold_list) {
        const itemId = item.i_id || (item.item && item.item.i_id);
        if (itemId == i_id) {
          // For size items, count bottles (bottle_quantity)
          // For regular items, count quantity (si_quantity)
          if (item.selected_size && item.bottle_quantity !== undefined) {
            totalBottles += item.bottle_quantity;
          } else {
            totalBottles += item.si_quantity || 0;
          }
        }
      }
      return totalBottles;
    },
    removeItem(i_id) {
      for (const item of this.sold_list) {
        const itemId = item.i_id || (item.item && item.item.i_id);
        if (itemId == i_id && !item.selected_size) {
          this.sold_list.splice(this.sold_list.indexOf(item), 1);
          break;
        }
      }

      // Recalculate discounts after removing item
      this.recalculateDiscounts();
    },
    removeItemByIndex(index) {
      const list = this.getSoldListByCurrentCurrency;
      if (index >= 0 && index < list.length) {
        const item = list[index];
        const actualIndex = this.sold_list.indexOf(item);
        if (actualIndex >= 0) {
          this.sold_list.splice(actualIndex, 1);
          // Recalculate discounts after removing item
          this.recalculateDiscounts();
        }
      }
    },
    increaseBottleQuantity(index) {
      const list = this.getSoldListByCurrentCurrency;
      if (index >= 0 && index < list.length) {
        const item = list[index];
        if (item.selected_size && item.bottle_quantity !== undefined) {
          const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 0;
          item.bottle_quantity++;
          item.si_quantity = item.bottle_quantity * sizeValue;
          this.sold_list = [...this.sold_list];
          this.recalculateDiscounts();
        }
      }
    },
    decreaseBottleQuantity(index) {
      const list = this.getSoldListByCurrentCurrency;
      if (index >= 0 && index < list.length) {
        const item = list[index];
        if (item.selected_size && item.bottle_quantity !== undefined && item.bottle_quantity > 1) {
          const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 0;
          item.bottle_quantity--;
          item.si_quantity = item.bottle_quantity * sizeValue;
          this.sold_list = [...this.sold_list];
          this.recalculateDiscounts();
        }
      }
    },
    updateBottleQuantity(index, quantity) {
      const list = this.getSoldListByCurrentCurrency;
      if (index >= 0 && index < list.length) {
        const item = list[index];
        if (item.selected_size && item.bottle_quantity !== undefined) {
          const newQuantity = parseInt(quantity) || 1;
          if (newQuantity < 1) {
            item.bottle_quantity = 1;
          } else {
            const sizeValue = parseFloat(item.selected_size.is_size.replace(/[^0-9.]/g, '')) || 0;
            item.bottle_quantity = newQuantity;
            item.si_quantity = newQuantity * sizeValue;
          }
          this.sold_list = [...this.sold_list];
          this.recalculateDiscounts();
        }
      }
    },
    getItemImage(item) {
      if (!item || !item.i_images) {
        return "../../assets/image/image_not_found.png";
      }
      
      // Get i_images (multiple images array)
      let images = item.i_images;
      
      // If i_images is a JSON string, parse it
      if (typeof images === 'string') {
        try {
          images = JSON.parse(images);
        } catch (e) {
          return "../../assets/image/image_not_found.png";
        }
      }
      
      // If it's an array with at least one image, return the first image
      if (Array.isArray(images) && images.length > 0 && images[0]) {
        return this.file_url + images[0];
      }
      
      return "../../assets/image/image_not_found.png";
    },
    async addMoreSizesToItem(index) {
      // This functionality can be added later if needed
      // For now, just show a message
      // eslint-disable-next-line no-unused-vars
      const _ = index; // Keep index parameter for future implementation
      this.$refs.ResultDialog.show({
        message: this.$t("feature_coming_soon") || "This feature is coming soon",
        okButton: this.$t("done"),
        isSuccess: false,
      });
    },

    async     removeInvoice() {
      const ok = await this.$refs.confirmDialogue.show({
        message:
          this.$t("are_you_sure_delete_invoice_number") + " " + this.in_id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.dispatch("edit_sale/deleteItem", this.in_id);
      }
    },
    showUnsavedWarning() {
      this.$refs.ResultDialog.show({
        message: this.$t("please_save_changes_before_printing"),
        okButton: this.$t("done"),
        isSuccess: false,
      });
    },
  },
};
</script>
<style scoped>
/* Hide everything except the invoice during print */
@media print {
  body * {
    visibility: hidden;
    margin: 0 !important;
    padding: 0 !important;
  }
  #invoice_print,
  #invoice_print * {
    visibility: visible;
  }
  #invoice_print {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
@media print {
  /* Reset unwanted print margins */
  @page {
    margin: 0;
    size: auto;
  }

  /* Preserve your original styling */
  #invoice_print {
    width: 100% !important;
    padding: 20px !important; /* Adjust as needed */
    margin: 0 !important;
    font-family: "Rabar_022" !important;
  }

  /* Force Tailwind spacing classes to work */
  .p-4 {
    padding: 1rem !important;
  }
  .my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}
</style>
